module.exports = __webpack_public_path__ + "media/custom/images/img2-ecce26d7dc73f4fef3d729cf0cff7dd0.jpg";